
export default function Subtitle({children}) {
    return (
        <h3 style={{fontWeight:'bold', padding:'20px 0'}}>{children}</h3>        
    )
}